import React from "react";
import { formatStringNumber } from "../../../services/Helpers/fonctions";
import { ToWords } from 'to-words';
export default function InvoiceTable({ descriptionData }) {
  const toWords = new ToWords({
    localeCode: 'fr-FR',
    converterOptions: {
      currency: false,
      ignoreDecimal: false,
      ignoreZeroCurrency: false,
      doNotAddOnly: false,
    }
  });
  return (
    <>
      <table className="invoice__table">
       <thead>
        <tr>
          <th>Description</th>
          <th>Chassis</th>
          <th>Prix(FG)</th>
        </tr>
      </thead>
      <tbody>
      {descriptionData.map((item, index) => (
        <tr key={index}>
          {index === 0 && (
            <td rowSpan={descriptionData.length}>Achat(s) d'Attestation d'enregistrement primaire</td>
          )}
          <td>{item.numeroChassis}</td>
            {index === 0 && (
             <td rowSpan={descriptionData.length}>{ formatStringNumber(descriptionData[0].prix)}</td>
          )}
        </tr>
        ))}
        
        
      </tbody>
      
     </table>
     <div className="invoice__table__footer">
      <div className="invoice__table__footer__total">
        <p>Prix Total</p>
        <p> { formatStringNumber(descriptionData[0].prix * descriptionData.length)} FG</p>
      </div>
     </div>
     <div className="invoice__table__footer__arrete">
        <p>Arrêtée la somme de <span>{ toWords.convert(parseInt(descriptionData[0].prix * descriptionData.length)) }</span> francs Guineens.</p>
        {/* <p>( 300 000 FG )</p> */}
     </div>
     <div className="invoice__table__footer__signature">
        
        <p>Signature  caissier (e)</p>
     </div>
    </>
    
  );
}
